import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../components/Layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Brand = makeShortcode("Brand");
const layoutProps = {
  _frontmatter
};
const MDXLayout = Layout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Configuring astroturf`}</h1>
    <Brand mdxType="Brand">astroturf</Brand> is right-sized for you and your needs. Quickly tweak behavior
based on easy to use configuration options.
    <h2>{`Options`}</h2>
    <p>{`Most options are available anywhere `}<Brand mdxType="Brand">{`astroturf`}</Brand>{` is used. Specify them
via your `}<inlineCode parentName="p">{`webpack.config`}</inlineCode>{` or `}<inlineCode parentName="p">{`babelrc`}</inlineCode>{` depending on use and need.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`extension`}</strong>{`: (default: `}<inlineCode parentName="p">{`'.module.css'`}</inlineCode>{`) the extension used for extracted style files. `}<inlineCode parentName="p">{`extension`}</inlineCode>{` generally informs the
flavor of CSS used (Sass, Less, etc) for the CLI or bundler to further process to plain css.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`stylesheetTagName`}</strong>{`: (default: `}<inlineCode parentName="p">{`'stylesheet'`}</inlineCode>{`) The tag identifier used to '
locate inline stylesheets declarations.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`cssTagName`}</strong>{`: (default: `}<inlineCode parentName="p">{`'css'`}</inlineCode>{`) The tag identifier used to locate inline
css literals and extract them.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`styledTagName`}</strong>{`: (default: `}<inlineCode parentName="p">{`'styled'`}</inlineCode>{`) The tag identifier used to locate components.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`enableCssProp`}</strong>{`: (default: `}<inlineCode parentName="p">{`true`}</inlineCode>{`) compiles `}<Brand mdxType="Brand">{`React.JS™`}</Brand>{` `}<inlineCode parentName="p">{`css`}</inlineCode>{`
component props to styled components.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`enableDynamicInterpolations`}</strong>{`: (default: `}<inlineCode parentName="p">{`'cssProp'`}</inlineCode>{`) enables or disables custom value
interpolation, You can disable this feature if you need to target environments that
do not support CSS custom properties.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`experiments`}</strong>{`: Opt in to any experimental features we are testing out.`}</p>
        <ul parentName="li">
          <li parentName="ul"><strong parentName="li">{`experiments.modularCssExternals`}</strong>{`: Set the css-modules flavor to `}<a parentName="li" {...{
              "href": "https://m-css.com/"
            }}><inlineCode parentName="a">{`modular-css`}</inlineCode></a>{` which provides
better inter-component referencing than the vanilla css-modules. `}<strong parentName="li">{`requires css-module-loader to be configured`}</strong></li>
        </ul>
      </li>
    </ul>
    <h2>{`Configuration File`}</h2>
    <Brand mdxType="Brand">astroturf</Brand> also supports configuration via localized configuration
files. We recommend that dependencies using astroturf use this approach to avoid
needing an single application-wide set of configuration options.
    <p>{`The supported file types are:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`.astroturfrc`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`.astroturfrc.json`}</inlineCode></li>
    </ul>
    <p>{`Both are assumed to JSON (with comments don't worry). You can also add configuration
to the `}<inlineCode parentName="p">{`astroturf`}</inlineCode>{` key in your `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      